import { render, staticRenderFns } from "./ActorInfo.vue?vue&type=template&id=d6f7359a&scoped=true&"
import script from "./ActorInfo.vue?vue&type=script&lang=ts&"
export * from "./ActorInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ActorInfo.vue?vue&type=style&index=0&id=d6f7359a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f7359a",
  null
  
)

export default component.exports